export class organizerStatusUrl {
    GET_ORGANIZER_STATUS_URL = "org/v1/status/[?organizerId]";
    UPDATE_DOCUMENT_STATUS_URL = "org/v1/status/downloaded-info";
}